/*
 * premium-reveal.js
 * Observador de scroll dedicado para la Homepage_Premium (tema Dawn).
 *
 * Aplica la Animacion_De_Entrada a los elementos marcados con la clase
 * `.premium-reveal` cuando entran al viewport, con escalonado (stagger)
 * automatico para grupos de elementos hermanos.
 *
 * Requisitos cubiertos:
 *  - 5.1: animar cuando >= 10% del elemento entra en el viewport (threshold 0.1).
 *  - 5.2: animar cada elemento una sola vez por carga (unobserve tras revelar).
 *  - 5.5: fallback sin IntersectionObserver -> mostrar estado final visible.
 *  - 5.6: prefers-reduced-motion -> mostrar estado final visible sin animacion.
 *  - 7.3: se carga con <script defer> desde cada seccion.
 *
 * Idempotente: una bandera global evita doble inicializacion.
 */
(function () {
  'use strict';

  if (window.__premiumRevealInitialized) return;
  window.__premiumRevealInitialized = true;

  var SELECTOR = '.premium-reveal';
  var VISIBLE = 'premium-reveal--visible';
  var THRESHOLD = 0.1;
  var STAGGER_MS = 90; // retraso entre elementos hermanos
  var STAGGER_MAX = 8; // tope para no acumular retrasos excesivos

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll(els) {
    els.forEach(function (el) {
      el.classList.add(VISIBLE);
    });
  }

  // Asigna un retraso escalonado a cada elemento segun su posicion entre los
  // hermanos .premium-reveal del mismo contenedor, salvo que ya traiga
  // --reveal-index definido desde Liquid.
  function assignStagger(els) {
    var counters = [];
    var parents = [];

    els.forEach(function (el) {
      if (el.style.getPropertyValue('--reveal-delay')) return;

      var hasIndex = el.style.getPropertyValue('--reveal-index');
      var idx;
      if (hasIndex !== '') {
        idx = parseInt(hasIndex, 10) || 0;
      } else {
        var parent = el.parentNode;
        var p = parents.indexOf(parent);
        if (p === -1) {
          parents.push(parent);
          counters.push(0);
          p = parents.length - 1;
        }
        idx = counters[p]++;
      }
      if (idx > STAGGER_MAX) idx = STAGGER_MAX;
      el.style.setProperty('--reveal-delay', idx * STAGGER_MS + 'ms');
    });
  }

  function init() {
    var els = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (els.length === 0) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      showAll(els);
      return;
    }

    assignStagger(els);

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= THRESHOLD) {
            entry.target.classList.add(VISIBLE);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: THRESHOLD, rootMargin: '0px 0px -5% 0px' }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
